<template>
  <img @click="changePage" :src="src" :class="{roundedCorners: selectedProductIsRounded}">
</template>
<style scoped>
img {
  height: 120px;
  background: white;
}
.roundedCorners {
  border-radius: 5px;
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: ['pageNum'],
  computed: {
    ...mapGetters(['thumbnails', 'selectedProductIsRounded']),
    src() {
      return this.thumbnails[this.pageNum];
    }
  },
  methods: {
    ...mapActions(['setPage']),
    changePage() {
      this.setPage(this.pageNum)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/EditorThumbnail.vue